//require('./bootstrap');

import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import App from './App.vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import router from './router/index.js'

import { loadLocaleMessages } from "./helpers";


import VueTailwind from 'vue-tailwind'
import {
    TInput,
    TTextarea,
    TSelect,
    TRadio,
    TCheckbox,
    TButton,
    TInputGroup,
    TCard,
    TAlert,
    TModal,
    TDropdown,
    TRichSelect,
    TPagination,
    TTag,
    TRadioGroup,
    TCheckboxGroup,
    TTable,
    TDatepicker,
    TToggle,
    TDialog,
  } from 'vue-tailwind/dist/components';
  const settings = {
    // Use the following syntax
    // {component-name}: {
    //   component: {importedComponentObject},
    //   props: {
    //     {propToOverride}: {newDefaultValue}
    //     {propToOverride2}: {newDefaultValue2}
    //   }
    // }
    't-input': {
      component: TInput,
      props: {
        classes: 'border-2 block w-full rounded text-gray-800'
        // ...More settings
      }
    },
    't-textarea': {
      component: TTextarea,
      props: {
        classes: 'border-2 block w-full rounded text-gray-800'
        // ...More settings
      }
    },
    't-modal': {
        component: TModal,
        props: {
          fixedClasses: {
            overlay: 'z-40  overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-opacity-50',
            wrapper: 'relative mx-auto z-50 max-w-lg px-3 py-12',
            modal: 'overflow-visible relative  rounded',
            body: 'p-3',
            header: 'border-b p-3 rounded-t',
            footer: ' p-3 rounded-b',
            close: 'flex items-center justify-center rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50'
          },
          classes: {
            overlay: 'bg-black',
            wrapper: '',
            modal: 'bg-white shadow',
            body: 'p-3',
            header: 'border-gray-100',
            footer: 'bg-gray-100',
            close: 'bg-gray-100 text-gray-600 hover:bg-gray-200',
            closeIcon: 'fill-current h-4 w-4',
            overlayEnterClass: 'opacity-0',
            overlayEnterActiveClass: 'transition ease-out duration-100',
            overlayEnterToClass: 'opacity-100',
            overlayLeaveClass: 'opacity-100',
            overlayLeaveActiveClass: 'transition ease-in duration-75',
            overlayLeaveToClass: 'opacity-0',
            enterClass: '',
            enterActiveClass: '',
            enterToClass: '',
            leaveClass: '',
            leaveActiveClass: '',
            leaveToClass: ''
          },
          variants: {
            danger: {
              overlay: 'bg-red-100',
              header: 'border-red-50 text-red-700',
              close: 'bg-red-50 text-red-700 hover:bg-red-200 border-red-100 border',
              modal: 'bg-white border border-red-100 shadow-lg',
              footer: 'bg-red-50'
            }
          }
        }
      },
      't-button': {
        component: TButton
        
      },
    // ...Rest of the components
  }
  let initialState = window.__INITIAL_STATE__;

  Vue.use(VueTailwind, settings)

  Vue.mixin({
    data: function () {
      return {
        get loggedIn() {
          return initialState.loggedIn;
        },
      };
    }
  });

const urlParams = new URLSearchParams(window.location.search);
let lang = urlParams.get('lang');
if (lang && lang !== undefined && lang.length == 2) {
  localStorage.setItem('lang', lang);
}
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'es', // set locale
    messages: loadLocaleMessages()
})
// creating a vue instance
const app = new Vue({
    router,
    i18n,
    el: '#app',
    components: {
        "App": App
    }
});